import React from "react"
import { storyblokEditable } from "@storyblok/react"

import { Login } from "gatsby-theme-gba"

const LoginEditable = ({ blok }) => (
  <div {...storyblokEditable(blok)} key={blok._uid}>
    <Login
      heading={blok.heading}
      subHeading={blok.subHeading}
      buttonText={blok.buttonText}
      type="login"
      passwordForgottenText={blok.passwordForgottenText}
    />
  </div>
)

export default LoginEditable
